import { createBrowserRouter } from 'react-router-dom';
import { HomePage } from '~/routes/home';
import { NotesPage } from '~/routes/notes';
import { CatalogPage } from '~/routes/catalog';
import { AdminPage } from '~/routes/admin';
import { Layout } from '~/components/Layout';

/**
 * Declarative-режим react-router v7.
 * Добавить страницу: создай компонент в src/routes/foo.tsx, добавь объект сюда.
 */
export const router = createBrowserRouter([
  { path: '/', element: <Layout><HomePage /></Layout> },
  { path: '/notes', element: <Layout><NotesPage /></Layout> },
  { path: '/catalog', element: <Layout><CatalogPage /></Layout> },
  { path: '/admin', element: <Layout><AdminPage /></Layout> },
]);
